export default {
  APP_ID: 'pages',
  EDITOR_NS: 'editor',
  DEFAULT_CONTENT_DIVIDER: 'default',
  TEST_DOMAIN_POSTFIX: '.pages.sportnet.online',
};
